import { useMemo } from "react";
import ImportModal from "../../components/modals/ImportModal";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useImportModal = () => {
    const { visible, open, close } = useVisible();

    const modal = useMemo(() => {
        return (
            <ImportModal
                isOpen={visible}
                close={close}
            />
        );
    }, [visible, close]);

    return { open, modal };
}